import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	ID = "id",
	ORDER_NUMBER = "orderNumber",
	CREATED_AT = "createdAt",
	STATUS = "status",
	TYPE = "type",
	ACCOUNT_AMOUNT_BEFORE = "accountAmountBefore",
	TRANSACTION_AMOUNT = "transactionAmount",
	ACCOUNT_AMOUNT_AFTER = "accountAmountAfter",
	COMMENT = "comment",
	TRANSACTION_AUTHOR = "transactionAuthor",
	DESCRIPTION = "description",

	FROM_TYPE = "fromType",
	FROM_IS_PROVIDER = "fromIsProvider",
	FROM_AMOUNT = "fromAmount",
	FROM_ENTITY_TYPE = "fromEntityType",
	FROM_CREDENTIALS = "fromCredentials",

	TO_TYPE = "toType",
	TO_IS_PROVIDER = "toIsProvider",
	TO_AMOUNT = "toAmount",
	TO_ENTITY_TYPE = "toEntityType",
	TO_CREDENTIALS = "toCredentials",

	PAYMENT_ACCOUNT_TYPE = "paymentAccountType",
	PAYMENT_ACCOUNT_PROVIDER = "paymentAccountIsProvider",
	PAYMENT_ACCOUNT_AMOUNT = "paymentAccountAmount",
	PAYMENT_ACCOUNT_ID = "paymentAccountId",
	PAYMENT_ACCOUNT_INTERNAL = "paymentAccountIsInternal",
	PAYMENT_ACCOUNT_CONFIGURATION_NAME = "paymentAccountConfigurationName",
	PAYMENT_ACCOUNT_CONFIGURATION_TYPE = "paymentAccountConfigurationType",
	PAYMENT_ACCOUNT_CONFIGURATION_PAYMENT_SYSTEM = "paymentAccountConfigurationPaymentSystem",

	TARGET_ACTION = "targetAction",

	TARGET_PAYMENT_ACCOUNT_TYPE = "targetPaymentAccountType",
	TARGET_PAYMENT_ACCOUNT_PROVIDER = "targetIsProvider",
	TARGET_PAYMENT_ACCOUNT_AMOUNT = "targetPaymentAccountAmount",
	TARGET_PAYMENT_ACCOUNT_ID = "targetPaymentAccountId",
	TARGET_PAYMENT_ACCOUNT_INTERNAL = "targetPaymentAccountIsInternal",
	TARGET_PAYMENT_ACCOUNT_CONFIGURATION_NAME = "targetPaymentAccountConfigurationName",
	TARGET_PAYMENT_ACCOUNT_CONFIGURATION_TYPE = "targetPaymentAccountConfigurationType",
	TARGET_PAYMENT_ACCOUNT_CONFIGURATION_PAYMENT_SYSTEM = "targetPaymentAccountConfigurationPaymentSystem",
}

export const translationTablePath =
	"pages.mainPage.pages.archives.tabs.transactions.content.columns.";

export const allColumns: ColumnId[] = Object.values(ColumnId);

const archivesTransactions = makeTable({
	allIds: Object.values(ColumnId),
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: allColumns,
	initialSortMethod: {
		column: ColumnId.CREATED_AT,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.ID]: 70,
		[ColumnId.ORDER_NUMBER]: 150,
		[ColumnId.CREATED_AT]: DATE,
		[ColumnId.STATUS]: 120,
		[ColumnId.TYPE]: 170,
		[ColumnId.ACCOUNT_AMOUNT_BEFORE]: 150,
		[ColumnId.TRANSACTION_AMOUNT]: 150,
		[ColumnId.ACCOUNT_AMOUNT_AFTER]: 150,
		[ColumnId.COMMENT]: 200,
		[ColumnId.TRANSACTION_AUTHOR]: 200,
		[ColumnId.DESCRIPTION]: 200,

		[ColumnId.FROM_TYPE]: 140,
		[ColumnId.FROM_IS_PROVIDER]: 140,
		[ColumnId.FROM_AMOUNT]: 140,
		[ColumnId.FROM_ENTITY_TYPE]: 140,
		[ColumnId.FROM_CREDENTIALS]: 400,

		[ColumnId.TO_TYPE]: 140,
		[ColumnId.TO_IS_PROVIDER]: 140,
		[ColumnId.TO_AMOUNT]: 140,
		[ColumnId.TO_ENTITY_TYPE]: 140,
		[ColumnId.TO_CREDENTIALS]: 400,

		[ColumnId.PAYMENT_ACCOUNT_TYPE]: 100,
		[ColumnId.PAYMENT_ACCOUNT_PROVIDER]: 140,
		[ColumnId.TARGET_ACTION]: 50,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_TYPE]: 100,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_PROVIDER]: 140,

		[ColumnId.PAYMENT_ACCOUNT_AMOUNT]: 140,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_AMOUNT]: 140,
		[ColumnId.PAYMENT_ACCOUNT_ID]: 100,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_ID]: 100,
		[ColumnId.PAYMENT_ACCOUNT_INTERNAL]: 100,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_INTERNAL]: 100,

		[ColumnId.PAYMENT_ACCOUNT_CONFIGURATION_NAME]: 100,
		[ColumnId.PAYMENT_ACCOUNT_CONFIGURATION_TYPE]: 140,
		[ColumnId.PAYMENT_ACCOUNT_CONFIGURATION_PAYMENT_SYSTEM]: 140,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_CONFIGURATION_NAME]: 100,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_CONFIGURATION_TYPE]: 140,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_CONFIGURATION_PAYMENT_SYSTEM]: 140,
	},
	initialResizable: Object.fromEntries(
		Object.values(ColumnId).map((id) => [id, true]),
	) as Record<ColumnId, boolean>,
	initialSortable: {
		[ColumnId.ID]: true,
		[ColumnId.ORDER_NUMBER]: true,
		[ColumnId.CREATED_AT]: true,
		[ColumnId.STATUS]: true,
		[ColumnId.TYPE]: true,
		[ColumnId.ACCOUNT_AMOUNT_BEFORE]: false,
		[ColumnId.TRANSACTION_AMOUNT]: false,
		[ColumnId.ACCOUNT_AMOUNT_AFTER]: false,
		[ColumnId.COMMENT]: true,
		[ColumnId.TRANSACTION_AUTHOR]: false,
		[ColumnId.DESCRIPTION]: false,

		[ColumnId.FROM_TYPE]: true,
		[ColumnId.FROM_IS_PROVIDER]: true,
		[ColumnId.FROM_AMOUNT]: true,
		[ColumnId.FROM_ENTITY_TYPE]: true,
		[ColumnId.FROM_CREDENTIALS]: true,

		[ColumnId.TO_TYPE]: true,
		[ColumnId.TO_IS_PROVIDER]: true,
		[ColumnId.TO_AMOUNT]: true,
		[ColumnId.TO_ENTITY_TYPE]: true,
		[ColumnId.TO_CREDENTIALS]: true,

		[ColumnId.PAYMENT_ACCOUNT_TYPE]: true,
		[ColumnId.PAYMENT_ACCOUNT_PROVIDER]: true,
		[ColumnId.TARGET_ACTION]: true,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_TYPE]: true,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_PROVIDER]: true,

		[ColumnId.PAYMENT_ACCOUNT_AMOUNT]: true,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_AMOUNT]: true,
		[ColumnId.PAYMENT_ACCOUNT_ID]: true,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_ID]: true,
		[ColumnId.PAYMENT_ACCOUNT_INTERNAL]: true,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_INTERNAL]: true,

		[ColumnId.PAYMENT_ACCOUNT_CONFIGURATION_NAME]: true,
		[ColumnId.PAYMENT_ACCOUNT_CONFIGURATION_TYPE]: true,
		[ColumnId.PAYMENT_ACCOUNT_CONFIGURATION_PAYMENT_SYSTEM]: true,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_CONFIGURATION_NAME]: true,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_CONFIGURATION_TYPE]: true,
		[ColumnId.TARGET_PAYMENT_ACCOUNT_CONFIGURATION_PAYMENT_SYSTEM]: true,
	},
});

export default archivesTransactions;
